import styled from 'styled-components';

const StyledControlsOverview = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  margin: auto 10px;
`;

export { StyledControlsOverview };
